/**
 * Get the maximum number of attempts for a Level 1 test
 */
export const getMaxAttempts = (testId: string | null): number => {
  if (!testId) return 10;
  
  // Default: 10 attempts for all tests including green attack
  return 10;
};
